import React from 'react'
import { Button, Theme, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useNavigate } from 'react-router-dom'
import { H1Notification } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()((theme: Theme) => ({
  blankPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  blankIcon: {
    color: theme.palette.primary.main,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}))

/*
 * Shows a Blank View for the notification page when there are no notifications
 */
const NotificationsBlankView: React.FC = () => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const { t } = useCustomTranslation()

  return (
    <div className={classes.blankPage}>
      <H1Notification className={classes.blankIcon} fontSize="large" />
      <Typography variant="h2">{t('notifications.blankText')}</Typography>
      <Typography>{t('notifications.blankSubText')}</Typography>
      <Button
        className={classes.button}
        variant="contained"
        onClick={() => {
          navigate('/')
        }}
      >
        {t('common.back')}
      </Button>
    </div>
  )
}

export default NotificationsBlankView
